import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';

import { BaseComponents } from '../base.component';

@Injectable()
export class BaseService extends BaseComponents{
    private request: any = null;
    protected httpClient: HttpClient;
    constructor(protected injectorObj:Injector) { 
       super(injectorObj);
       this.httpClient = this.injectorObj.get(HttpClient);
       
    }
    httpClientOptions() {
        const httpClientOptions = {
            headers: {
                'Content-Type': 'application/json',
            },
            observe: 'response' as 'body'
        };
        return httpClientOptions;
    }
    input(param: any) {
        return param;
    }
    output(result: any) {
        return result;
    }
    connector(path: any, payload: any) {
        const url = `${environment.endpointBackend}` + path;
        const body = this.input(payload);
        return this.httpClient.post(url, body);
    }

    post(path: any, payload: any) {
        if (this.request) {
            this.request.unsubscribe();
        }
        return new Promise(async (resolve) => {
            this.request = this.connector(path, payload).subscribe(
                res => {
                    //console.log('xxx',res)
                    resolve(this.output(res));
                },
                err => {
                    resolve(err);
                },
                () => {
                    this.request = null;
                }
            );
        });
    }


}
